__turbopack_context__.v({
  "StandardPage": "StandardPage-module__sbIAWa__StandardPage",
});
